import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiPost, operationsClient } from '@/lib/api';
import { opsEstimateEndpoints } from '@/lib/api/endpoints';
import { estimateKeys } from '@/lib/queryKeys';
import type { Estimate } from '@/types/estimate';

interface RepriceEstimateBody {
  /**
   * When true, the server re-reads the address-level tax exemption from the
   * linked ContactAddress before repricing, so address-level exemption changes
   * are picked up. Customer-exemption changes are picked up regardless.
   */
  refreshTaxExemption?: boolean;
}

/**
 * Re-prices an existing estimate via POST on the operations microservice.
 * Used to resolve tax-exemption drift (and general re-pricing) on repriceable
 * (DRAFT/REVIEW) estimates.
 */
export const useRepriceEstimate = createMutationHook<
  Estimate,
  RepriceEstimateBody & { id: string }
>({
  mutationFn: ({ id, ...body }) =>
    apiPost<Estimate, RepriceEstimateBody>(
      operationsClient,
      opsEstimateEndpoints.reprice(id),
      body,
    ),
  onSuccess: (data, _variables, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: estimateKeys.lists() });
    void queryClient.invalidateQueries({ queryKey: estimateKeys.detail(data.id) });
    toast.success('Estimate re-priced');
  },
});
